import clsx from 'clsx'
import React from 'react'

import styles from './Skeleton.module.scss'

export const Skeleton = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement> & { className?: string }) => (
  <div className={clsx(styles.skeleton, className)} {...props} />
)

export const SkeletonList = ({
  className,
  count = 1,
}: {
  className?: string
  count?: number
}) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Skeleton key={`skeleton-${index}`} className={className} />
    ))}
  </>
)

